import { validateReadingEvidenceConfig } from '../minigames/reading-evidence/ReadingEvidenceConfig.js';

export const MAIN_IDEA_MEADOW_PASSAGE = validateReadingEvidenceConfig({
  id: 'main-idea-meadow-fireflies',
  skillId: 'literacy.main-idea.supporting-details',
  title: 'Why Fireflies Blink',
  pages: [
    'On warm evenings, fireflies rise from tall grass. Their bodies make a cool light. The light does not burn like a candle.',
    'Each kind of firefly has its own flash pattern. A firefly uses that pattern to find others of the same kind in the dark.',
    'The light can also warn hungry animals. A bright blink says that a firefly may taste bitter, so some hunters leave it alone.',
  ],
  question: 'What is the main idea of the whole passage?',
  claimChoices: [
    { id: 'light-important-jobs', text: 'Fireflies use their light for more than one important job.' },
    { id: 'all-insects-glow', text: 'All insects glow when the sun goes down.' },
    { id: 'fireflies-need-candles', text: 'Fireflies need candlelight to fly at night.' },
  ],
  evidenceDetails: [
    { id: 'patterns-find-kind', pageIndex: 1, text: 'Flash patterns help fireflies find others of the same kind.' },
    { id: 'blink-warns-hunters', pageIndex: 2, text: 'A bright blink can warn hungry animals away.' },
    { id: 'warm-evening', pageIndex: 0, text: 'Fireflies rise from grass on warm evenings.' },
    { id: 'not-candle-hot', pageIndex: 0, text: 'A firefly’s light does not burn like a candle.' },
  ],
  correctClaimId: 'light-important-jobs',
  requiredEvidenceIds: ['patterns-find-kind', 'blink-warns-hunters'],
  hints: [
    'A main idea must fit every page, not just one sentence.',
    'Look for two different jobs done by the same thing.',
    'One detail is about finding other fireflies. Another is about warning hunters.',
  ],
  completionWorldEvent: 'main-idea-meadow-bloomed',
  successMessage: 'The strongest details feed the main idea. The whole meadow blooms!',
});
